

export const VALID_USERNAME_REGEX: RegExp = /(^[a-zA-Z0-9][_a-zA-Z0-9-.]+(\.[_a-zA-Z0-9-]+)*$)|(^[a-zA-Z0-9_]+([\w-\.]*)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]+|[0-9]{1,3})(\]?)$)/;
export const VALID_PASSWORD_REGEX: RegExp = /^((?!^(\d+|[a-zA-Z]+)$)^[a-zA-Z0-9]{8,12})$/;
export const VALID_SIMPLE_PWD_REGEX: RegExp = /^[a-zA-Z0-9]{5,12}$/;
export const VALID_EMAIL_REGEX: RegExp = /^[a-zA-Z0-9_+]+([\w-\.]*)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]+|[0-9]{1,3})(\]?)$/;

export const VALID_ZIP_CODE_REGEX: RegExp = /^[0-9]{5}(?:-[0-9]{4})?$/;




/* 
Phone number: VALID_INTL_PHONE_REGEX
/^[a-zA-Z0-9_.-+]*$/;
/\+(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\W*\d\W*\d\W*\d\W*\d\W*\d\W*\d\W*\d\W*\d\W*(\d{1,2})$/;    
*/


/*
Email: /^[a-zA-Z0-9_+]+([\w-\.]*)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/
*/
